'use strict';

module.exports = ['$translateProvider', function ($translateProvider) {
    $translateProvider.translations('it', require('../languages/it'));
    $translateProvider.translations('en', require('../languages/en'));
}];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-core/configs/TranslateProvider.js
// module id = 306
// module chunks = 0